const apiBaseUrl = process.env.REACT_APP_API_URL || "https://api.namasteworld.tours";
const imageBaseUrl = process.env.REACT_APP_IMAGE_URL ||
    (process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace(/\/api\/?$/, "/uploads") : "https://api.namasteworld.tours/uploads");

const config = {
    API_BASE_URL: apiBaseUrl,
    IMAGE_URL: imageBaseUrl
};

export default config;
